export  const PRODUCT_API = "PRODUCT_API";
export const LOAD = "LOAD";
export const STORY = 'STORY';
export const CATEGORY = "CATEGORY";
export const ALL_POST = 'ALL_POST';
export const WALLMAG_ALL = 'WALLMAG_ALL'
export const CATEGORY_DATA = 'CATEGORY_DATA'
export const RELATED_FEEDS = 'RELATED_FEEDS'
export const USER_POSTS = 'USER_POSTS'
